export const isEanWeighable = (ean: string): boolean => {
  return ean.startsWith('2')
}

export const normalizeEanForCapture = (ean: string) => {
  if (isEanWeighable(ean)) {
    return ean.substring(0, 7)
  }
  return ean
}

export const extractWeight = (ean: string): number | null => {
  if (
    ean === null ||
    ean.length !== 13 ||
    !/^\d+$/.test(ean) ||
    !isEanWeighable(ean)
  ) {
    return null
  }
  return parseInt(ean.substring(7, 12))
}
